import { useNode } from "@craftjs/core";
import * as React from "react";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
} from "@/components/editor/shared/block-wrapper";
import { PaddingWrapper } from "@/components/editor/themes/crosby/constants";

import { Wrapper } from "./divider-component-styles";

export type DividerProps = {
  inverted?: boolean;
  children: React.ReactNode;
};
export default function Divider(props: DividerProps) {
  const {
    connectors: { connect },
    id: nodeId,
  } = useNode();

  return (
    <BlockBackgroundColorWrapper ref={connect} id={nodeId}>
      <PaddingWrapper>
        <BlockMaxWidthWrapper>
          <Wrapper data-testid="divider-wrapper" inverted={props.inverted}>
            {props.children}
          </Wrapper>
        </BlockMaxWidthWrapper>
      </PaddingWrapper>
    </BlockBackgroundColorWrapper>
  );
}

Divider.craft = {
  isCanvas: true,
  custom: {
    displayName: "Divider",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
  },
};
